import { PillTheme } from "./pill-theme";
import { ReturnTagSource, Tag, TagKind } from "./tag";

export enum SystemReturnTagName {
  RMA_CREATION_FAILED = "RMA creation failed",
  LABEL_CREATION_FAILED = "Label creation failed",
  EXCHANGE_OUT_OF_STOCK = "Out of Stock",
  LABEL_EXPIRATION_UNSUCCESSFUL = "Label expiration unsuccessful",
  REFUND_PAYMENT_FAILED = "Refund payment failed",
}

export const RmaCreationFailedTag = createReturnTag(
  SystemReturnTagName.RMA_CREATION_FAILED,
  PillTheme.DANGER,
);
export const LabelCreationFailedTag = createReturnTag(
  SystemReturnTagName.LABEL_CREATION_FAILED,
  PillTheme.SOLID_ORANGE,
);
export const OutOfStockTag = createReturnTag(
  SystemReturnTagName.EXCHANGE_OUT_OF_STOCK,
  PillTheme.NEUTRAL_YELLOW,
);

export const LabelExpirationUnsuccessfulTag = createReturnTag(
  SystemReturnTagName.LABEL_EXPIRATION_UNSUCCESSFUL,
  PillTheme.DANGER,
);

export const RefundPaymentFailedTag = createReturnTag(
  SystemReturnTagName.REFUND_PAYMENT_FAILED,
  PillTheme.SOLID_ORANGE,
);

export interface ReturnTag extends Tag {
  name: SystemReturnTagName;
  pillTheme: PillTheme;
  source: ReturnTagSource.REDO;
  kind: TagKind.RETURN;
}

export function createReturnTag(
  name: SystemReturnTagName,
  pillTheme: PillTheme,
): ReturnTag {
  return {
    name,
    pillTheme,
    source: ReturnTagSource.REDO,
    kind: TagKind.RETURN,
  };
}
